const page = document.querySelector('.pfy-landing-page');
if (page) {
  const builderReady = customElements.whenDefined('pfy-plate-builder').then(() => {
    const builder = page.querySelector('pfy-plate-builder');
    const compact = page.querySelector('[data-pfy-compact]');
    if (!builder || !compact || builder.dataset.compactReady) return builder;
    builder.dataset.compactReady = 'true';
    const form = builder.querySelector('form');
    const registrationStep = builder.querySelector('[name="registration"]').closest('.pfy-step');
    const preview = builder.querySelector('.pfy-preview-column');
    registrationStep.after(preview);
    const options = document.createElement('details');
    options.className = 'pfy-ad-builder-options';
    const summary = document.createElement('summary');
    summary.textContent = compact.dataset.moreLabel;
    const icon = page.querySelector('.pfy-ad-questions summary svg')?.cloneNode(true);
    if (icon) summary.append(icon);
    options.append(summary);
    builder.querySelector('.pfy-order').before(options);
    for (const element of [builder.querySelector('input[name$="-mode"]').closest('fieldset'), builder.querySelector('input[name$="-border"]').closest('fieldset'), builder.querySelector('.pfy-ev-step')]) options.append(element);
    const title = builder.querySelector('.pfy-heading h2');
    title.textContent = compact.dataset.builderLabel;
    const continueIcon = page.querySelector('.pfy-ad-button svg')?.cloneNode(true);
    if (continueIcon) builder.querySelector('.pfy-continue > span:last-child').replaceWith(continueIcon);
    form.addEventListener('submit', () => {
      if (builder.querySelector('.pfy-error:not([hidden])') && options.querySelector('[aria-invalid="true"]')) options.open = true;
    });
    return builder;
  });
  const jump = async style => {
    const builder = await builderReady;
    if (!builder) return;
    if (style) {
      const option = builder.querySelector(`input[name$="-style"][value="${style}"]`);
      if (option) { option.checked = true; option.dispatchEvent(new Event('change', {bubbles: true})); }
    }
    const input = builder.querySelector('[name="registration"]');
    document.getElementById('pfy-build').scrollIntoView({behavior:'auto',block:'start'});
    input.focus({preventScroll:true});
  };
  page.querySelectorAll('[data-pfy-build], [data-pfy-style]').forEach(link => {
    link.addEventListener('click', event => { event.preventDefault(); jump(link.dataset.pfyStyle); });
  });
}
